import { locales } from '../locales_de'
export const config = {
  colors: require('../colors.json'),
  locales: locales.perimeter
}
